import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HybridStorageKeys, HybridStorageService } from '../app/services/hybrid-storage.service';

@Injectable({
  providedIn: 'root'
})
export class LoginDebugService {
  private debugModeSubject = new BehaviorSubject<boolean>(false);
  public debugMode$ = this.debugModeSubject.asObservable();

  constructor(private hybridStorageService: HybridStorageService) {
    this.loadDebugModeSetting();
  }

  /**
   * Load debug mode setting from storage on service initialization
   */
  private async loadDebugModeSetting(): Promise<void> {
    try {
      const debugMode = await this.hybridStorageService.getItem<boolean>(
        HybridStorageKeys.LoginDebug_Enabled,
        true // Use cookies for this small boolean value
      );

      if (debugMode !== null && debugMode !== undefined) {
        this.debugModeSubject.next(debugMode);
        console.warn('[LoginDebug] Debug mode loaded from storage:', debugMode);
      }
    } catch (error) {
      console.error('[LoginDebug] Failed to load debug mode setting:', error);
    }
  }

  /**
   * Get current debug mode state
   */
  get isDebugModeEnabled(): boolean {
    return this.debugModeSubject.value;
  }

  /**
   * Toggle debug mode on/off
   */
  async toggleDebugMode(): Promise<boolean> {
    const newValue = !this.debugModeSubject.value;
    await this.setDebugMode(newValue);
    return newValue;
  }

  /**
   * Set debug mode to specific value
   */
  async setDebugMode(enabled: boolean): Promise<void> {
    try {
      await this.hybridStorageService.setItem(
        HybridStorageKeys.LoginDebug_Enabled,
        enabled,
        true // Use cookies for this small boolean value
      );

      this.debugModeSubject.next(enabled);
      console.warn('[LoginDebug] Debug mode set to:', enabled);
    } catch (error) {
      console.error('[LoginDebug] Failed to save debug mode setting:', error);
    }
  }
}
